import script from "./Category.vue?vue&type=script&setup=true&lang=js"
export * from "./Category.vue?vue&type=script&setup=true&lang=js"

import "./Category.vue?vue&type=style&index=0&id=df62f0e4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df62f0e4"]])

export default __exports__